import axios from 'axios';
import {
  AUTH_REQUEST,
  AUTH_ERROR,
  AUTH_SUCCESS,
  AUTH_LOGOUT,
  API_URL,
  SET_NOTIFICATION,
  AUTH_REQUEST_PROVIDER
} from "../constant";
import { USER_REQUEST } from "../constant";
import { setToken } from "@/helpers";
import * as Sentry from "@sentry/vue";
import ErrorMessage from "../../localization/index.json"

const state = {
  token: localStorage.getItem('user-token') || '',
  status: '',
};

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
};

const actions = {
  [AUTH_REQUEST]: ({commit, dispatch}, user) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST);
      commit(SET_NOTIFICATION,{ type: null });
      axios({url: `${API_URL}/auth/local`, data: user, method: 'POST' })
        .then(resp => {
          const token = resp.data.jwt;
          setToken(token);
          commit(AUTH_SUCCESS, resp);
          dispatch(USER_REQUEST);
          resolve(resp);
        })
        .catch(err => {
          commit(AUTH_ERROR, err);
          commit(SET_NOTIFICATION,{ type: 'error', messages: [ErrorMessage[err.response.data.message[0].messages[0].id]] });
          localStorage.removeItem('user-token');
          Sentry.captureException(err);
          reject(err);
        })
    })
  },

  [AUTH_LOGOUT]: ({commit}) => {
    return new Promise((resolve) => {
      commit(AUTH_LOGOUT);
      localStorage.removeItem('user-token');
      delete axios.defaults.headers.common['Authorization'];
      resolve();
    })
  },

  [AUTH_REQUEST_PROVIDER]: async ({commit, dispatch}, data) => {
    commit(AUTH_REQUEST);
    commit(SET_NOTIFICATION,{ type: null });
    try {
      const res = await axios({url: `${API_URL}/auth/${data.provider}/callback?${data.query}`});
      setToken(res.data.jwt);
      commit(AUTH_SUCCESS, res);
      dispatch(USER_REQUEST);
      return res;
    } catch(e) {
      if (e.response.data.message[0].messages[0].id === 'Auth.form.error.email.taken') {
        commit(SET_NOTIFICATION,{ type: 'error', messages: ['This email has already taken'] });
      }
      else {
        commit(SET_NOTIFICATION,{ type: 'error', messages: e.response.data.message[0].messages });
      }
      commit(AUTH_ERROR, e);
      localStorage.removeItem('user-token');
      Sentry.captureException(e);
      throw Error(e);
    }
  },
}

const mutations = {
  [AUTH_REQUEST]: state => {
    state.status = 'loading';
  },
  [AUTH_SUCCESS]: (state, token) => {
    state.status = 'success';
    state.token = token;
  },
  [AUTH_ERROR]: state => {
    state.status = 'error';
  },
  [AUTH_LOGOUT]: state => {
    state.token = '';
  }
}

export default {
  state,
  getters,
  actions,
  mutations
};
